<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('item_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <template v-if="permission==1">
                <router-link to="/item/create" class="btn btn-outline-primary btn-sm no-bor">
                    <i class="fa fa-plus-circle"></i> {{$t('new')}}
                </router-link>
                <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print">
                    <i class="fa fa-print" aria-hidden="true"></i>
                    {{$t('print')}}
                </button>
                <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="exportExcel">
                    <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                    {{$t('export_excel')}}
                </button>
                <div class="pull-right">
                    <div class="btn-group tool-group" role="group">
                        <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(1)" :class="{active:viewType==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(0)" :class="{active:viewType==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                    </div>
                </div>
            </template>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-4 col-md-3 col-lg-2">
                            <label class="label-control blue">&nbsp;</label>
                            <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                        </div>
                        <div class="col-sm-4 col-md-3 col-lg-2">
                            <div class="form-group">
                                <label class="label-control blue">{{ $t('item_category_list') }}</label>
                                <select class="form-control form-control-sm" v-model="query.CategoryId">
                                    <option value="">{{$t('all')}}</option>
                                    <option v-for="ret in categories" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-4 col-md-3 col-lg-2" v-if="permission==1">
                            <div class="form-group">
                                <label class="label-control blue">{{ $t('vendor') }}</label>
                                <div>
                                    <VendorDropdown @select="vendorSelected"></VendorDropdown>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">&nbsp;</label>
                                <div>
                                    <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm no-bor v-top">
                        <thead>
                            <tr>
                                <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('Num')">{{ $t('item_code') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('Name')">{{ $t('item_name') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting" v-if="permission==1">
                                    <span class="sort-field" @click="onSort('VendorName')">{{ $t('vendor')}}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('CategoryName')">{{ $t('category') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('UomName')">{{ $t('uom') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting" v-if="permission==1">
                                    <span class="sort-field" @click="onSort('Cost')">{{ $t('cost') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting">
                                    <span class="sort-field" @click="onSort('Price')">{{ $t('price_sale') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting" v-if="permission==1">
                                    <span class="sort-field" @click="onSort('BeginQty')">{{ $t('begin_stock') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting" v-if="permission==1">
                                    <span class="sort-field" @click="onSort('EndingQty')">{{ $t('ending_stock') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting" v-if="permission==1">
                                    <span class="sort-field" @click="onSort('TotalCost')">{{ $t('total_cost') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                                <th class="sorting" v-if="permission==1">
                                    <span class="sort-field" @click="onSort('TotalPrice')">{{ $t('total_price') }}</span>
                                    <i class="fa fa-sort" aria-hidden="true"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(ret, index) in records">
                                <tr style="vertical-align: middle;" :class="{'bg-default':index%2==0}" :key="index">
                                    <td class="text-center">{{index+1}}</td>
                                    <td>{{ ret.Num }}</td>
                                    <td>
                                        <router-link v-if="permission==1" :to="{ name: 'item_edit', params:{ id:ret.Id }}">{{ret.Name}}</router-link>
                                        <span v-else>{{ret.Name}}</span>
                                    </td>
                                    <td v-if="permission==1">{{ret.VendorName}}</td>
                                    <td>{{ret.CategoryName}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td v-if="permission==1" class="text-right"><router-link :to="{name: 'cost_item_history', params: {id:ret.Id}}">{{$dollar(ret.Cost)}}</router-link></td>
                                    <td class="text-right">{{$dollar(ret.Price)}}</td>
                                    <td v-if="permission==1" class="text-right">{{$number(ret.BeginQty, '0,0.[00]')}}</td>
                                    <td v-if="permission==1" class="text-right" :class="genColor(ret)">
                                        <router-link :to="{name: 'report_stock_summary', params: {id:ret.Id}}" target="_blank">{{$number(ret.EndingQty, '0,0.[00]')}}</router-link>
                                    </td>
                                    <td v-if="permission==1" class="text-right">{{$dollar(ret.TotalCost)}}</td>
                                    <td v-if="permission==1" class="text-right">{{$dollar(ret.TotalPrice)}}</td>
                                </tr>
                            </template>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th :colspan="permission==1?8:6" class="text-right">{{$t('total')}} :</th>
                                <th v-if="permission==1" class="text-right">{{$number(summary.BeginStock, '0,0.[00]')}}</th>
                                <th v-if="permission==1" class="text-right">{{$number(summary.EndStock, '0,0.[00]')}}</th>
                                <th v-if="permission==1" class="text-right">{{$dollar(summary.Cost)}}</th>
                                <th v-if="permission==1" class="text-right">{{$dollar(summary.Price)}}</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { VendorDropdown } from '../Vendors';
    export default {
        components: { VendorDropdown },
        data: function(){
            return {
                query:{
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    Text: '',
                    ProductTypeId: '',
                    CategoryId: '',
                    VendorId: '',
                    SortType: '',
                    SortField: ''
                },
                records:[],
                categories: [],
                viewType: 0,
                summary: {
                    BeginStock: 0,
                    EndStock: 0,
                    Cost: 0,
                    Price: 0,
                }
            }
        },
        created: function(){
            if(this.routerNum == 100){
                this.query.Text = this.filter.Text;
            }else{
                this.$store.state.routenum = 100;
            }
            this.$api().post('category').then(res => {
                if (this.$isValid(res)) {
                    this.categories = res.data.Data;
                }
            });
            this.toList();
        },
        methods: {
            toList: function(){
                var loading = this.$loading.show();
                this.$api().post('item/list', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.records = res.data.Data;
                        this.summary = res.data.Json.Summary;
                        this.query.Total = res.data.Total;
                    }
                }).finally(function(){ loading.hide();});
            },
            print: function(){
                window.open('/print/price/list?t=0', '_blank');
            },
            paging(e){
                this.query.Page = e;
                this.toList();
            },
            viewTypeChange(n){
                this.viewType = n;
                this.$store.state.filter.coa.IsGroup = n==0?false:true;
                this.toList();
            },
            genColor(item){
                var ret = '';
                if(item.AlertQty > 0){
                    if(item.EndingQty <= 0) ret = 'bg-danger';
                    else if(item.EndingQty <= item.AlertQty) return 'bg-warning';
                }
                return ret;
            },
            vendorSelected(item){
                this.query.VendorId = item.Id;
            },
            exportExcel(){
                var loading = this.$loading.show();
                this.$api()({
                    url: this.$base() + 'item/export/excel',
                    method: 'post',
                    data: this.query,
                    responseType: 'blob'
                }).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'items.xlsx');
                    document.body.appendChild(link);
                    link.click();
                }).finally(function(){ loading.hide();});
            },
            onSort(field){
                this.query.SortField = field;
                if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
                else this.query.SortType = 'ASC';
                this.toList();
            }
        },
        computed: {
            routerNum: function(){
                return this.$store.state.routenum;
            },
            filter: function(){
                return this.$store.state.filter;
            },
            permission(){
                return this.$store.state.userGroup;
            }
        },
        destroyed(){
            this.$store.state.filter.Text = this.query.Text;
        }
    }
</script>
<style scoped>
    .table.v-top tr>td{
        vertical-align: middle;
    }
    .bg-default{
        background: #f2f2f2 !important;
    }
</style>